import loadable from '@loadable/component';
import { BoxIndicator } from '@classtinginc/design-system';

const CreateAnnouncementPage = loadable(
  () => import('./CreateAnnouncementPage'),
  {
    fallback: <BoxIndicator />,
  }
);

export default CreateAnnouncementPage;
